import { InvertColorsOffIcon } from './InvertColorsOffIcon';

/**
 * author: Google
 * id B3F155FA-57B1-4781-AC45-98A1A47673DC
 * name invert-colors-off
 * version: 3.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/invert-colors-off.svg
 * tags
 * - Color 
 */
export const InvertColoursOffIcon = InvertColorsOffIcon;
export default InvertColoursOffIcon